const RECT_WIDTH = 80;
const RECT_HEIGHT = 30;
const TEXT_BASELINE = 15;

// Padding for text inside the rectangle (4px vertical, 8px horizontal)
const PADDING_VERTICAL = 4;
const PADDING_HORIZONTAL = 8;

const X_OFFSET = 32;
const Y_OFFSET = 14.5;
const X_AXIS_TEXT_BASELINE = 24;

const MIN_WIDTH = RECT_WIDTH;
const MAX_WIDTH = 200;
export {
  RECT_WIDTH,
  RECT_HEIGHT,
  TEXT_BASELINE,
  PADDING_VERTICAL,
  PADDING_HORIZONTAL,
  X_OFFSET,
  Y_OFFSET,
  X_AXIS_TEXT_BASELINE,
  MIN_WIDTH,
  MAX_WIDTH,
};
